/**
 * Internal API module - NOT exported to consumers
 */

import { SocketConnectionConfig } from "../types";
import { clientBus } from "../utils/eventBus";

export interface BotInfo {
  chatBot: string;
  taskBotId: string;
}

export interface AuthenticateParams {
  source: string;
  conversationId: string;
  isSmartAssist: boolean;
  experience?: string;
}

export interface AuthenticatePayload {
  assertion: string;
  botInfo: BotInfo;
  token: Record<string, unknown>;
}

export interface ApiConfig {
  baseUrl: string;
  token: string;
  assertion: string;
  botInfo: BotInfo;
}

/**
 * Internal API client for AgentAI backend calls
 * @internal
 */
export class AgentAIApi {
  private accessToken: string = '';
  private baseUrl: string;
  private service: string = 'agentassist';
  private userId: string = '';
  public getService(): string {
    return this.service;
  }
  public getAuthToken(): string {
    return this.accessToken;
  }
  public getAccountId(): string {
    return this.accountId;
  }
  public getUserId(): string {
    return this.userId;
  }
  private connection: SocketConnectionConfig;
  // private assertion: string;
  private botInfo: BotInfo;
  private accountId: string = '';

  private endPoint: Record<string, string> = {
    load: '/api/v1/aa/load',
  };

  constructor(config: SocketConnectionConfig) {
    this.connection = config;
    this.baseUrl = config.domainURL;
    // this.assertion = config.assertion;
    this.botInfo = {
      chatBot: "Sample Chat Bot",
      taskBotId: config.botId,
    };
  }

  /**
   * Authenticate and load agent assist session
   * Returns the fetch Promise - caller handles .then() / .catch()
   * @internal
   */
  async authenticate(params: AuthenticateParams): Promise<any> {
    const { source, conversationId, isSmartAssist, experience } = params;

    const endpoint = `${this.baseUrl}/${this.service}${this.endPoint.load}?source=${encodeURIComponent(source)}&conversationId=${encodeURIComponent(conversationId)}&isSmartAssist=${isSmartAssist}&experience=${encodeURIComponent(experience || 'chat')}`;

    // Build headers
    let headers = new Headers({});
    let headerObj: any = { iid: this.connection.botId, accountId: this.accountId, Authorization: 'bearer ' + this.accessToken };
    headerObj['Content-Type'] = 'application/json';
    Object.keys(headerObj).forEach((key) => {
      headers.set(key, headerObj[key]);
    });

    // Build request payload
    const payload: AuthenticatePayload = {
      assertion: this.connection.token,
      botInfo: this.botInfo,
      token: {},
    };
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const error: any = await response.json();
      clientBus.emitError((error?.message as any) || 'Something went wrong');
      return null;
    };
    return await response.json();
  }

  setAuthInfo(authInfo: any) {
    this.accessToken = authInfo.accessToken;
    this.accountId = authInfo.accountId;
    this.service = authInfo.invokeNewAAService ? 'agentai' : 'agentassist';
    this.userId = authInfo.userId;
  }
}
